module.exports = __webpack_public_path__ + "static/media/bg-intro-desktop.140dd315.png";